const blocks = document.querySelectorAll('.p3vg');

function setActiveState(block, item){
  let activeItem = block.querySelector('.p3vg__item.active');

  if(activeItem && activeItem !== item){
    activeItem.classList.remove('active');
  }

  item.classList.add('active');
}

if(!!blocks){
  blocks.forEach((block) => {
    const items = block.querySelectorAll('.p3vg__item');

    items.forEach((item) => {
      const button = item.querySelector('.btn');

      item.addEventListener('mouseenter', () => {
        const focusedButton = block.querySelector('.btn.isFocused');
        if(!focusedButton || focusedButton === button){
          setActiveState(block, item);
        }
      });

      button.addEventListener('focus', () => {
        button.classList.add('isFocused');
        setActiveState(block, item);
      });

      button.addEventListener('blur', () => {
        button.classList.remove('isFocused');
      })
    });

    // Check if any posts have a 'featured in: component'
    const features = block.querySelectorAll('.featured_in');
    if(features.length){
      block.classList.add('has_features');
    }
  });
}
